import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import { Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import lang from '../../../../assets/i18n/en.json';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  nameValidation,
  validateNumber,
  emailValidation,
} from '../../../../utils/Utils';
import { Dropdown } from 'primereact/dropdown';
import allImages from '../../../../assets/images/allImages';
// import { InviteEnterpriseClient } from '../../../../Mutations/Mutations';
import { InviteEnterpriseClientV2 } from '../../../../Mutations/MutationsUpdated';

export const SendInvitation = (props) => {
  const PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  const [newUserDetails, setNewUserDetails] = useState({
    firstname: '',
    lastname: '',
    role: null,
    mobile: '',
    email: '',
  });
  const [errors, setError] = useState({
    email: false,
    emailError: '',
    firstName: false,
    firstNameError: '',
    lastName: false,
    lastNameError: '',
    mobileno: false,
    mobilenoError: '',
    role: false,
    roleError: '',
  });
  const roleOptions = [
    { name: 'ENTERPRISE_ADMIN', code: 'ENTERPRISE_ADMIN' },
    { name: 'ENTERPRISE_USER', code: 'ENTERPRISE_USER' },
  ];
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  
  //Assign mutaions to variable
  const [sendInviteEnterpriseClient, { loading }] = useMutation(
    InviteEnterpriseClientV2,
    {
      onCompleted: (data) => {
        
        setShowConfirmationPopup(true);
        props.onHide();
        // isLoginResponse(data);
      },

      onError: ({ graphQLErrors }) => {
        toast.error(
          toastResponse('error', ERROR.CUSTOM.CODE.ERROR_API_RESPONSE),
        );
      },
    },
  );
  
  const fnCreateEnterprise = () => {
    const input = {
      email: newUserDetails.email,
      firstName: newUserDetails.firstname,
      lastName: newUserDetails.lastname,
      // phoneNumber: newUserDetails.mobile,
      role: newUserDetails.role.code,
      clientId: props.entityID,
    };

    try {
      // toast.success(toastResponse('success', 'Invite Mutation Is Not Available'));
      //Call mutaion with parameter later
      sendInviteEnterpriseClient({
        // variables: { enterpriseId: props.entityID, input: input },
        variables: { input },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };
  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          closeButton
          className="modal-header px-8 pt-8 pb-4"
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder">Invite User</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 py-0 modal-body send-invitation-model"
          style={{ borderBottom: '#fff', margin: '0%' }}
        >
          <form>
            <div
              className=""
              style={{
                marginBottom: '1.125rem',
                display: props.type === 'employee' ? 'none' : 'block',
              }}
            >
              {/* <img src={props.entityLogo ? props.entityLogo : allImages.infoIcon} className='me-2' style={{ height: '2rem' }} />{props.entityName ? props.entityName : ''} */}
              <img
                src={
                  props.entityLogo
                    ? props.entityLogo
                    : allImages.defaultEnterpriseLogo
                }
                className="me-2"
                style={{ height: '2.5rem' }}
                alt="entity_logo"
              />
              {props.entityName ? props.entityName : ''}
            </div>
            <div className="mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.FIRSTNAME.LABEL}</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.firstName}
                onChange={(e) => {
                  nameValidation('firstName', e?.target?.value, setError);
                  setNewUserDetails((newUserDetails) => ({
                    ...newUserDetails,
                    firstname: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.firstNameError}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.LASTNAME.LABEL}</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.lastName}
                onChange={(e) => {
                  nameValidation('lastName', e?.target?.value, setError);
                  setNewUserDetails((newUserDetails) => ({
                    ...newUserDetails,
                    lastname: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.lastNameError}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>Role</Form.Label>
              <Dropdown
                style={{
                  zIndex: 9999,
                  width: '100%',
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  color: '#5e6278',
                }}
                className="customDropdown"
                value={newUserDetails.role}
                options={roleOptions}
                onChange={(e) => {
                  setNewUserDetails({ ...newUserDetails, role: e.value });
                }}
                optionLabel="name"
              />
            </div>
            <div className="mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.MOBILENUMBER.LABEL}</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                maxLength={10}
                isInvalid={errors.mobileno}
                onChange={(e) => {
                  validateNumber(e?.target?.value, setError);
                  setNewUserDetails((newUserDetails) => ({
                    ...newUserDetails,
                    mobile: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobilenoError}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.EMAIL.LABEL}</Form.Label>
              <Form.Control
                type="email"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.email}
                onChange={(e) => {
                  emailValidation(e?.target?.value, errors, setError);
                  setNewUserDetails((newUserDetails) => ({
                    ...newUserDetails,
                    email: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.emailError}
              </Form.Control.Feedback>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <button
            type="button"
            className="customTable action-btn btn btn-primary btn-hover-color m-0"
            disabled={
              !(
                newUserDetails.firstname &&
                newUserDetails.lastname &&
                newUserDetails.role &&
                newUserDetails.mobile &&
                newUserDetails.email &&
                !errors.firstname &&
                !errors.lastname &&
                !errors.role &&
                !errors.mobile &&
                !errors.email
              )
            }
            onClick={fnCreateEnterprise}
          >
            Send Invite{' '}
            {loading && (
              <i
                className="spinner-grow spinner-grow-sm ms-3"
                role="status"
              />
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <ConfirmationOnSendInvite
        show={showConfirmationPopup}
        onHide={() => setShowConfirmationPopup(false)}
        type = {props?.type}
      />
    </>
  );
};

const ConfirmationOnSendInvite = (props) => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-4"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title className="mx-auto">
            <div className="fw-bolder">Invitation Sent Successfully</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-8 py-0 modal-body send-invitation-model text-center">
          <img src={allImages.avtar} className="img-fluid mb-4" alt="avtar" />
          <p className="mb-4">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.
          </p>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer mx-auto"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <button
            type="button"
            className="customTable action-btn btn btn-primary btn-hover-color m-0"
            onClick={() => {
              props.onHide();
              window.location.href =
              props?.type === 'employee' ? '/enterprise/enterprise-admin/user-management' : '/enterprise/bond-admin/dashboard';
            }}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
